<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="25" height="23.778"><path d="M12.5 0l2.949 9.084H25l-7.723 5.61 2.949 9.084-7.726-5.614-7.728 5.615 2.949-9.084L0 9.084h9.549z"/></svg>
</template>

<script>
	export default {
		name: "Star"
	}
</script>